export default "__VITE_ASSET__DAk1wGft__"